import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { ChartContainer, ChartTooltip, ChartTooltipContent } from "@/components/ui/chart";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Cell } from "recharts";
import { Users } from "lucide-react";
import { TopSupplier } from '@/gen/inventory/common_pb';

const supplierChartConfig = {
  total_products: {
    label: "Total Products",
    color: "#1e40af", // blue-800
  },
};

interface TopSuppliersChartProps {
  topSuppliers: TopSupplier[];
}

const TopSuppliersChart: React.FC<TopSuppliersChartProps> = ({ topSuppliers }) => {
  const top7Suppliers = topSuppliers.slice(0, 7);
  return (
    <Card className="bg-[#FCFCFC] h-full">
      <div className="m-4 flex items-center text-gray-600">
        <Users className="w-4 h-4" />
        <p className="text-sm ml-1">Top Suppliers</p>
      </div>
      <hr className="my-4" />
      <CardHeader>
        <CardTitle>Your Top Suppliers</CardTitle>
        <CardDescription>Top 7 suppliers</CardDescription>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={200}>
          <ChartContainer config={supplierChartConfig} className="h-full w-full">
            <BarChart
              data={top7Suppliers}
              layout="vertical"
              margin={{ left: 0 }}
            >
              <YAxis
                dataKey="supplierName"
                type="category"
                tickLine={false}
                tickMargin={10}
                axisLine={false}
              />
              <XAxis dataKey="totalItems" type="number" hide />
              <ChartTooltip cursor={false} content={<ChartTooltipContent hideLabel />} />
              <Bar dataKey="totalItems" layout="vertical" radius={5}>
                {top7Suppliers.map((entry, idx) => (
                  <Cell key={`cell-${idx}`} fill="#1d4ed8" />
                ))}
              </Bar>
            </BarChart>
          </ChartContainer>
        </ResponsiveContainer>
      </CardContent>
      <CardFooter className="flex-col items-start gap-2 text-sm">
        <div className="leading-none text-muted-foreground">
          Showing top seven suppliers based on your available stock
        </div>
      </CardFooter>
    </Card>
  );
};

export default TopSuppliersChart; 